"use client"

import { useCurrentPrice } from "@/hooks/product_no_design/useCurrentPrice"
import { useProductName } from "@/hooks/product_no_design/useProductName"
import { useAppSelector } from "@/hooks/redux"
import { formatCurrencyUSD } from "@/utils/app/formatCurrencyUSD"
import { Form, Row, Typography } from "antd"
import ProductColors from "./ProductColors"
import ProductSizes from "./ProductSizes"
import ProductQuantity from "../../Product/ProductQuantity"
import ProductAddToCartButton from "../ProductAddToCartButton"

const ProductPanel = () => {
  const description = useAppSelector(state => state.product.product_no_design.data?.product_details?.description)
  const productName = useProductName()
  const { price  } = useCurrentPrice()

  return (
    <Form>
      <Row>
        <Typography.Title level={2} style={{ marginBottom: 0 }}>
          {productName}
        </Typography.Title>
      </Row>
      <Row>
        <Typography.Title level={3} style={{ marginBottom: 0 }}>
          {formatCurrencyUSD.format(price)}
        </Typography.Title>
      </Row>

      <ProductColors />
      <ProductSizes />
      <ProductQuantity />
      
      <Row style={{ marginBlock: '2rem' }}>
        <ProductAddToCartButton />
      </Row>

      <Row>
        <div className="ql-editor" dangerouslySetInnerHTML={{ __html: description || "" }} />
      </Row>
    </Form>
  )
}

export default ProductPanel